import { Component, Input, OnInit } from '@angular/core';

import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { ControlTypeName } from '../../types/control-type-name';
import { ValueControlViewModel } from '../../types/control.types';
import { RegionSelectionType } from '../../types/property.types';
import { ControlValidateMoment } from '../../types/validator.types';
import { RegionType } from '../region-selection/region-type';
import { isJSON } from '../../utils/utils';

@Component({
  selector: 'df-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.scss']
})
export class RegionComponent extends AbstractValueControlBase<RegionValueControlViewModel> implements OnInit {
  @Input() split = '/';

  type = ControlTypeName.regionSelection;
  result: any;
  regionInfo: any;
  showResult: string;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getModelValue() {
    if (!this.model.value) {
      return new RegionType();
    }
    return this.model.value;
  }

  setModelValue(val: RegionType) {
    if (!val) {
      this.model.value = undefined;
      // this.model.value = '';
      this.regionInfo = {};
    } else {
      if (typeof val === 'string' && isJSON(val)) {
        val = JSON.parse(val);
      }
      this.model.value = val;
      this.regionInfo = val;
    }
    this.setShowResult();
  }

  resultData(e: any) {
    this.result = e;
    this.model.value = this.result;
    this.validateAtMoment(ControlValidateMoment.Input);
    this.validateAtMoment(ControlValidateMoment.Change);

    this.broadControlValueChange();
  }

  setShowResult() {
    if (!this.model.value) {
      this.showResult = '';
      return;
    }

    this.showResult =
      `${this.getRegionText('province', '')}` +
      `${this.getRegionText('city', '')}` +
      `${this.getRegionText('district', '')}`;
  }

  private getRegionText(name: string, defaultValue: string): string {
    const value = this.model.value[name];
    if (!value) {
      return defaultValue;
    }
    return value;
  }
}

interface RegionValueControlViewModel extends ValueControlViewModel<RegionType> {
  selectionType: RegionSelectionType;
}
